export default {
  PROMO_CODE: 'HUB-VELOE',
  DEFAULT_OFFER: 12,
  PROMO_CODES_ALLOWED: [],
  CONTENTFUL: {
    SPACE: '486fbuk7vhzs',
    ACCESS_TOKEN: 'ef73aac58d415790712277bef9edecfe0c0518ed56c3203202fbfafaeae2eb6b',
    ENTRY_ID: '2mkN1TkUrd694rACpoPNns',
    TEAM_ENTRY_ID: '68fX7SQlA7wDA38GO85raB',
  },
}
